import React from 'react';
import { Chip, useT } from '@repo/common';

import { ReactComponent as CancelIcon } from '@repo/common/assets/icons/16px/icon_16px_cancel.svg';

const SelectedSkills = ({ selected, onRemove }) => {
  const t = useT();
  return (
    <div className='flex flex-col items-start p-0 w-full'>
      <div className='flex flex-row items-center pb-2 gap-[6px] w-full'>
        <div className='typo-b14 tabletH:typo-b14Strong text-text-secondary tabletH:text-text-primary'>
          {t('Selected :', '선택한 스킬 :')}
        </div>
      </div>
      <div className='flex flex-wrap gap-2'>
        {selected.length > 0 ? (
          selected.map((skill) => (
            <Chip
              key={skill}
              onClick={() => onRemove(skill)}
              icon={<CancelIcon />}
              iconPosition='after'
              state='selected'
            >
              {skill}
            </Chip>
          ))
        ) : (
          <div className='typo-b12 text-text-placeholder'>
            {t('No skills added yet', '아직 추가된 스킬이 없습니다')}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedSkills;
